'use client';

import React from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  percentage: number;
}

export const ProgressBar = ({ currentStep, totalSteps, percentage }: ProgressBarProps) => {
  return (
    <div className="w-full max-w-[800px] mx-auto px-0 md:px-4">
      <div className="h-[14px] md:h-4 rounded-full overflow-hidden relative" style={{ background: '#FFFFFF' }}>
            {/* Shimmer animation overlay */}
            <div 
              className="absolute inset-0 w-[200%] h-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
              style={{
                animation: 'shimmer 2s linear infinite'
              }}
            />
            {/* Progress bar fill */}
            <div 
              className="h-full rounded-full transition-all duration-300 ease-out relative z-10 shadow-sm" 
              aria-valuemin={0} 
              aria-valuemax={100} 
              aria-valuenow={percentage} 
              role="progressbar" 
              aria-label={`Form progress: ${percentage}% complete`}
              style={{ 
                width: `${percentage}%`,
                background: 'linear-gradient(90.52deg, #FFC32B 17.3%, #FB43DA 54.99%, #D684FF 63.48%, #17E2EA 82.72%)'
              }}
            />
          </div>
    </div>
  );
};

